export const HTTP_METHODS: any = {
    GET: "GET",
    POST: "POST",
    PATCH: "PATCH",
    PUT: "PUT",
    DELETE: "DELETE",
    HEAD: "HEAD",
    REFRESH: "REFRESH"
};



// WEBPACK FOOTER //
// ./src/core/services/sync-up/index.ts